import React from "react";
import HiddenInput from "components/shared/form/HiddenInput";

const PipedriveMetadataBlock = () => {
  return <HiddenInput name={["lending", "pipedrive_id"]} />;
};

export default PipedriveMetadataBlock;
